import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILabel } from 'src/models/general';
import { IAdvanceSearchOnm } from 'src/models/onlineMedia';

export interface IAdvanceSearchOfflineMedia
  extends Omit<IAdvanceSearchOnm, 'excludeMediaList'> {
  phrases: string[];
  labelObjectList: ILabel[];
  // exclueLabelObjectList: ILabel[];
}

export const initialState: IAdvanceSearchOfflineMedia = {
  sentiment: [],
  validationList: [],
  mediaList: [],
  includeKeywords: [],
  excludeKeywords: [],
  searchType: 'allSearch',
  // for include label
  labelList: [],
  labelObjectList: [],
  // for exclude label
  // excludeLabelList: [],
  // exclueLabelObjectList: [],
  phrases: [],
  queryStringBooleanOperator: 'and',
  tier: [],
  showEmptyLabel: false
};

export const advanceSearchOfflineMedia = createSlice({
  name: 'advanceSearchOfflineMedia',
  initialState,
  reducers: {
    reducerUpdateAdvanceSearchOfflineMediaPhrases: (
      state: IAdvanceSearchOfflineMedia,
      action: PayloadAction<string[]>
    ) => {
      state.phrases = action.payload;
    },
    reducerUpdateAdvanceSearchOfm: (
      state: IAdvanceSearchOfflineMedia,
      action: PayloadAction<Partial<IAdvanceSearchOfflineMedia>>
    ) => {
      state.mediaList = action.payload.mediaList;
      state.searchType = action.payload.searchType;
      state.includeKeywords = action.payload.includeKeywords;
      state.excludeKeywords = action.payload.excludeKeywords;
      state.sentiment = action.payload.sentiment;
      state.validationList = action.payload.validationList;
      state.labelList = action.payload.labelList;
      state.labelObjectList = action.payload.labelObjectList;
      state.tier = action.payload.tier;
      // state.excludeLabelList = action.payload.excludeLabelList;
      // state.exclueLabelObjectList = action.payload.exclueLabelObjectList;
      // state.showEmptyLabel = action.payload.showEmptyLabel;
    },
    reducerUpdateAdvanceSearchOfmMediaList: (
      state: IAdvanceSearchOfflineMedia,
      action: PayloadAction<string[]>
    ) => {
      state.mediaList = action.payload;
    }
  }
});

export const {
  reducerUpdateAdvanceSearchOfflineMediaPhrases,
  reducerUpdateAdvanceSearchOfm,
  reducerUpdateAdvanceSearchOfmMediaList
} = advanceSearchOfflineMedia.actions;

export default advanceSearchOfflineMedia.reducer;
